// extracted by mini-css-extract-plugin
export default {"root":"_2mnqI","label":"_3UqSI"};